import React, { Fragment } from 'react'

// icons
import { faCalculator } from '@fortawesome/free-solid-svg-icons'

// components
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import ItemArticuloPrecio from './ItemArticuloPrecio'

// route
import { withRouter } from 'react-router-dom'

// services
import routes from '../../Routes'
import HeaderActionsButtons from '../Custom/HeaderActionsButtons'
import HeaderPagination from '../Custom/HeaderPagination'
import useArticuloPrecio from './hooks/useArticuloPrecio'
import usePagination from './hooks/usePagination'

const visibleButtons = {
    create: true,
    import: true,
    export: true,
    deleted: false,
    search: true,
    listas: true
}

const ArticuloPrecio = ({ history }) => {
    const { handleExport } = useArticuloPrecio(history)

    const {
        articuloPrecios,
        listaPrecio,
        listaPrecios,
        setListaPrecio,
        setIsLoad,
        page,
        totalRegister,
        totalPage,
        nextPage,
        previousPage,
        handleBuscador,
        disabledExportButton
    } = usePagination(history, true)

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faCalculator} title={'Precios Articulos'} />
                </div>

                <HeaderActionsButtons
                    history={history}
                    routes={routes.ARTICULO_PRECIOS}
                    visibleButtons={visibleButtons}
                    handleImprimir={() => handleExport(listaPrecio?.id ?? 0)}
                    handleBuscador={handleBuscador}
                    listaPrecios={listaPrecios}
                    listaPrecio={listaPrecio}
                    setListaPrecio={setListaPrecio}
                    disabledExportButton={disabledExportButton}
                />

                <HeaderPagination
                    page={page}
                    totalPage={totalPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    totalRegister={totalRegister}
                />

                <table className="table table-striped mt-3 text-center">
                    <thead>
                        <tr>
                            <th scope="col">Codigo</th>
                            <th scope="col">Articulo</th>
                            <th scope="col">Precio Final</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {articuloPrecios.map((articuloPrecio) => (
                            <ItemArticuloPrecio
                                key={parseInt(articuloPrecio.id)}
                                articuloPrecio={articuloPrecio}
                                setIsLoad={setIsLoad}
                                history={history}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </Fragment>
    )
}

export default withRouter(ArticuloPrecio)
